import { useList } from "@/hooks/queries";

export const useGetRolesList = () => {
  const { data, ...queryResults } = useList("behaviors");
  return {
    roles: data?.data ?? [],
    ...queryResults,
  };
};
